const ACCENT_COLOR_KEY = 'tt-accent-color';

export const saveAccentColor = (color: string) => {
  localStorage.setItem(ACCENT_COLOR_KEY, color);
};

export const getStoredAccentColor = () =>
  localStorage.getItem(ACCENT_COLOR_KEY);
